import { useTranslation } from "react-i18next";

const SUFFIX_RE = /^(.+?)(\s*\(.+\))$/;

export function useResolveI18n() {
  const { t } = useTranslation();

  return (value: string) => {
    if (!value.includes(".")) return value;

    return value
      .split(", ")
      .map((part) => {
        const direct = t(part, { defaultValue: part });
        if (direct !== part) return direct;

        const match = SUFFIX_RE.exec(part);
        if (!match) return part;

        const [, key, suffix] = match;
        const translated = t(key!, { defaultValue: key! });
        return translated !== key ? `${translated}${suffix}` : part;
      })
      .join(", ");
  };
}
